<template>
<el-row  class="width-1150-important">
  <el-row>
  <el-row>
          <el-col 
        style="width: 100%;">
          <el-col
            :span="20"
            class="fundSelector_tab"
          >
            风险指标
          </el-col>
          <el-col
            :span="4"
            class="right_text_align"
          >
            <el-select
              class="fundSelector_Company"
              v-model="perforamncePeriod"
              placeholder="请选择时间周期"
              :disabled="invalidPeriod"
            >
              <el-option
                v-for="item in periodList"
                :key="item.period"
                :label="item.value"
                :value="item.period"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-col>
        </el-row>
        <div  
        class="table-line"
        style="margin-top:15px; margin-bottom:5px;"
        ></div>
        <el-row v-loading="performanceLoading">
        <el-table
      :data="performanceTableData"
      style="width: 100%; margin-top: 5px;"
      :cell-class-name="cellStyle"
    >
      <el-table-column
        prop="dpNameLocal"
        label="名称"
        width="350"
      ></el-table-column>
      <el-table-column
        prop="fund"
        :label="categoryDisplayName"
        width="300"
        align="right"
        header-align="center"
      >
       <template slot-scope="scope">
          {{ scope.row.fund | fixValue }}
        </template>
      </el-table-column>
      <el-table-column
        prop="category"
        :label="categoryAverageName"
        width="250"
        align="right"
        header-align="center"
      >
      <template slot-scope="scope">
          {{ scope.row.category | fixValue }}
        </template>
      </el-table-column>
      <el-table-column
        prop="benchmark"
        :label="benchmarkName"
        min-width="250"
        align="right"
        header-align="center"
      >
      <template slot-scope="scope">
          {{ scope.row.benchmark | fixValue }}
        </template>
      </el-table-column>
      </el-table>
      <el-col
       class="risk_date left_text_align"
       style="color:#909399; margin-top: 10px;"
       >起止日期：{{performanceStartEnd}}
       </el-col>
       </el-row>
       </el-row>
       <el-row style="margin-top:35px;">
       <el-row>
       <el-col
            :span="24"
            class="fundSelector_tab"
          >
            历史回报
          </el-col>
        </el-row>
       <div  
        class="table-line"
        style="margin-top:15px; margin-bottom:5px;"
        ></div>
       <el-row v-loading="returnLoading">
       <el-table
      :data="returnTableData"
      style="width: 100%; margin-top: 5px;"
      :cell-class-name="cellStyle"
    >
      <el-table-column
        prop="periodLocal"
        label="名称"
        width="350"
      ></el-table-column>
      <el-table-column
        prop="fund"
        :label="categoryDisplayName"
        width="300"
        header-align="center"
        align="right"
      >
      <template slot-scope="scope">
          {{ scope.row.fund | fixValue }}
        </template>
      </el-table-column>
      <el-table-column
        prop="category"
        :label="categoryAverageName"
        width="250"
        header-align="center"
        align="right"
      >
      <template slot-scope="scope">
          {{ scope.row.category | fixValue }}
        </template>
      </el-table-column>
      <el-table-column
        prop="benchmark"
        :label="benchmarkName"
        min-width="250"
        header-align="center"
        align="right"
      >
      <template slot-scope="scope">
          {{ scope.row.benchmark | fixValue }}
        </template>
      </el-table-column>
      </el-table>
      <el-col
       :span="24"
       class="risk_date left_text_align"
       style="color:#909399; margin-top: 10px;"
       >截止日期：{{periodEndDate}}
       </el-col>
       </el-row>
       </el-row>
       <el-row style="margin-top:35px; margin-bottom:25px;">
       <el-row>
       <el-col 
        style="width: 100%;">
          <el-col
            :span="20"
            class="fundSelector_tab"
          >
            风险收益分布
          </el-col>
          <el-col
            :span="4"
            class="right_text_align"
          >
            <el-select
              class="fundSelector_Company"
              v-model="riskPeriod"
              placeholder="请选择时间周期"
              :disabled="invalidPeriod"
            >
              <el-option
                v-for="item in periodList"
                :key="item.period"
                :label="item.value"
                :value="item.period"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-col>
        </el-row>
        <div  
        class="table-line"
        style="margin-top:15px;"
        ></div>
      <el-row v-loading="riskLoading">
            <el-col
              :span="5"
              class="left_text_align"
            >
      <canvas id="canvasKey"></canvas>      
      <el-col
       class="risk_date left_text_align"
       style="color:#909399;"
       >起止日期：{{riskStartEnd}}
       </el-col>
      </el-col>
        <el-col
          :span="19"
        >
        <el-row>
        <el-col
              class="right_text_align"
            >
        <canvas id="canvasAR" width="800" class="right_text_align" height="110" style="display:block;"></canvas>      
        </el-col>
        </el-row>
        <div  
        class="table-line"
        ></div>
        <el-row>
        <el-col
              class="right_text_align"
            >
        <canvas id="canvasMD" width="800" class="right_text_align" height="110" style="display:block;"></canvas>      
        </el-col>
        </el-row>
        <div  
        class="table-line"
        ></div>
        <el-row>
            <el-col
              class="right_text_align"
            >
        <canvas id="canvasSR" width="800" class="right_text_align" height="110" style="display:block;"></canvas>      
        </el-col>
        </el-row>
        </el-col>      
      </el-row>
      <div  
        class="table-line"
        ></div>
      </el-row>
    </el-row>
</template>
<script>
import { Message } from "element-ui";
import { period } from "./mixin/analystRatingPeriod";
import { AnalystRatingDetail } from "./AnalystRatingDetail";
import {
    getAnalystRatingPerformance,getAnalystRatingReturn,riskDistributionChart,getAnalystRatingRisk,categoryChart
} from "../../api/analystRating";
const componentsCommon=require("cb-components-common").default;
const checkResponseStatus=componentsCommon.common.checkResponseStatus;

export default {
  mixins: [period],
    data() {
        return {
            performanceLoading: "",
            returnLoading: "",
            riskLoading: "",
            invalidPeriod: false,
            performanceTableData: [],
            returnTableData: [],
            categoryName:"积极配置 - 大盘成长",
            categoryDisplayName:"积极配置 - 大盘成长奖牌基金",
            benchmarkName:"积极配置 - 大盘成长",
            categoryAverageName:"积极配置 - 大盘成长",
            periodEndDate: "",
            performanceStartEnd: "",
            perforamncePeriod: "成立以来",
            riskStartEnd: "",
            riskPeriod: "成立以来",
            annualReturn: {},
            maxDrawdown: {},
            sharpeRatio: {},
            params: {
              categoryName: "积极配置 - 大盘成长"
            },
            perforamnceParams: {
                categoryName: "积极配置 - 大盘成长",
                period: "since-inception"
            },
            riskParams: {
                categoryName: "积极配置 - 大盘成长",
                period: "since-inception"
            }
        };
    },
    filters: {
        fixValue(value) {
            if (value != undefined && value != null && value != "") {
                return value.toFixed(2);
            } 
        },
    },
     mounted() {
      const self = this;
      self.loadingData();
     },
     watch: {
      perforamncePeriod: function(val) {
            const self = this;
            self.perforamnceParams.period = val;
            self.getAnalystRatingPerformance();
        },
      riskPeriod: function(val) {
            const self = this;
            self.riskParams.period = val;
            self.getRiskDistributionChart();
        },
    },
methods: {
        loadingData() {
            const self = this;
            self.getAnalystRatingPeriod(self.params);
            self.invalidPeriod = self.params.invalidPeriod;
            self.getAnalystRatingPerformance();
            self.getAnalystRatingReturn();
            self.getRiskDistributionChart();
        },
        getAnalystRatingPerformance() {
            const self = this;
            self.performanceLoading = true;
            getAnalystRatingPerformance(self.perforamnceParams)
                .then((response) => {
                    let result = response.data;
                    if (result == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000,
                        });
                        Message.close = function () {};
                    } else {
                        if (checkResponseStatus(result, self)) {
                            if (
                                Number(result._meta.response_status) === 200032
                            ) {
                                Message({
                                    message:
                                        "非常抱歉，数据正在更新中，请稍后再试！",
                                    type: "warning",
                                    duration: 3 * 1000,
                                });
                                Message.close = function () {};
                            } else {
                                self.performanceTableData = result.data.dataPoints;
                                self.categoryName = result.data.fundName;
                                self.categoryAverageName = result.data.categoryName;
                                self.benchmarkName = result.data.benchmarkName;
                                if(result.data.startDate && result.data.endDate) {
                                  self.performanceStartEnd = result.data.startDate + " — " + result.data.endDate;
                                }
                                else {
                                  self.performanceStartEnd = "--";
                                }
                                
                            }
                        }
                    }
                })
                .catch((err) => {
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000,
                    });
                    Message.close = function () {};
                })
                .finally((r) => {
                    self.performanceLoading = false;
                });
        },
        getAnalystRatingReturn() {
            const self = this;
            self.returnLoading = true;
            getAnalystRatingReturn(self.params)
                .then((response) => {
                    let result = response.data;
                    if (result == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000,
                        });
                        Message.close = function () {};
                    } else {
                        if (checkResponseStatus(result, self)) {
                            if (
                                Number(result._meta.response_status) === 200032
                            ) {
                                Message({
                                    message:
                                        "非常抱歉，数据正在更新中，请稍后再试！",
                                    type: "warning",
                                    duration: 3 * 1000,
                                });
                                Message.close = function () {};
                            } else {
                                self.returnTableData = result.data.dataPoints;
                                self.categoryName = result.data.fundName;
                                self.categoryAverageName = result.data.categoryName;
                                self.benchmarkName = result.data.benchmarkName;
                                self.periodEndDate = result.data.endDate;
                            }
                        }
                    }
                })
                .catch((err) => {
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000,
                    });
                    Message.close = function () {};
                })
                .finally((r) => {
                    self.returnLoading = false;
                });
        },
        getRiskDistributionChart() {
            const self = this;
            self.riskLoading = true;
            getAnalystRatingRisk(self.riskParams)
                .then(response => {
                    let jsonData = response.data;
                    if (jsonData == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000
                        });
                        Message.close = function() {};
                    } else {
                        if (checkResponseStatus(jsonData, self)) {
                            let result = jsonData.data;
                            self.annualReturn = result.annualReturn;
                            self.maxDrawdown = result.maxDrawdown;
                            self.sharpeRatio = result.sharpeRatio;
                            if(result.startDate && result.endDate) {
                              self.riskStartEnd = result.startDate + " — " + result.endDate;
                            }
                            else {
                              self.riskStartEnd = "--";
                            }
                            riskDistributionChart(
                                "canvasAR",
                                "年化收益",
                                result.annualReturn, self
                            );
                            riskDistributionChart(
                                "canvasMD",
                                "最大回撤",
                                result.maxDrawdown, self
                            );
                            riskDistributionChart(
                                "canvasSR",
                                "夏普比率",
                                result.sharpeRatio, self
                            );
                            categoryChart("canvasKey", self.categoryDisplayName, self.params);
                        }
                    }
                })
                .catch(err => {
                    self.riskLoading = false;
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function() {};
                    console.log(err);
                })
                .finally(r => {
                    self.riskLoading = false;
                });   
        },
        loadingDataByCategory(categoryName) {
            const self = this;
            self.categoryName = categoryName;
            self.params.categoryName = categoryName;
            self.perforamnceParams.categoryName = categoryName;
            self.riskParams.categoryName = categoryName;
            self.perforamncePeriod = "since-inception";
            self.riskPeriod = "since-inception";
            let fundNameIndex = categoryName.indexOf("基金");
            if(fundNameIndex > 0) {
                self.categoryDisplayName = categoryName.replace("基金", "奖牌基金");
            }
            else {
                self.categoryDisplayName = categoryName + "奖牌基金";
            }
            self.loadingData();
        },
        cellStyle ({row, column, rowIndex, columnIndex}) {
          if(columnIndex > 0) {
            if(column.width == 300) {
              return 'cellStyle_300px';
            }
            else {
              return 'cellStyle_250px';
            }
          }
          else {
            return '';
          }
      }
}
    }
</script>
<style lang="scss">
@import "../../public/sass/components/analystRating";

.cellStyle_300px {
        padding-right: 11% !important;
    }
.cellStyle_250px {
        padding-right: 9% !important;
    }
</style>